import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'
import PVTSVG from '../../assets/redirect-options/pvt.svg?react'
import IntakeSVG from '../../assets/redirect-options/onboarding-introduction.svg?react'
import useAuthUser from 'react-auth-kit/hooks/useAuthUser'
import { ROUTES } from '../../routes'
import { useTranslation } from "react-i18next"

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  align-items: center;
  justify-content: center;
  padding: 0 24px;
  gap: 24px;
`

const CardsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 48px;
`

const Card = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 400px;
  min-height: 320px;
  border: 2px solid #d6d7db;
  border-radius: 16px;
  padding: 24px;
  cursor: pointer;
`

const CardImg = styled.div`
  display: flex;
  align-self: center;
`

const RedirectOptions = () => {
  const navigate = useNavigate()
  const auth = useAuthUser()
  const { t } = useTranslation('common')

  const handleCardClick = path => {
    navigate(path)
  }

  return (
    <Container>
      <span style={{ fontSize: 28, fontWeight: 600 }}>
        {t('redirect_options.header')}
      </span>
      <CardsContainer>
        <Card onClick={() => handleCardClick(ROUTES.PVT)}>
          <CardImg>
            <PVTSVG />
          </CardImg>
          <span
            style={{
              fontSize: 24,
              fontWeight: 700,
              color: '#27292E',
              marginTop: '24px',
            }}
          >
            {t('redirect_options.cards.pvt.title')}
          </span>
          <span style={{ fontSize: 14, color: '#27292E' }}>
            {t('redirect_options.cards.pvt.subtitle', { missingPVTCount: auth.missingPVTCount })}
          </span>
        </Card>
        <Card onClick={() => handleCardClick(ROUTES.INTAKE)}>
          <CardImg>
            <IntakeSVG />
          </CardImg>
          <span
            style={{
              fontSize: 24,
              fontWeight: 700,
              color: '#27292E',
              marginTop: '24px',
            }}
          >
            {t('redirect_options.cards.intake.title')}
          </span>
          <span style={{ fontSize: 14, color: '#27292E' }}>
            {t('redirect_options.cards.intake.subtitle')}
          </span>
        </Card>
      </CardsContainer>
    </Container>
  )
}

export default RedirectOptions
